var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-item',{attrs:{"card":"item_conference","tabs":_vm.tabs,"activeTab":_vm.activeTab,"isFull":true,"id":_vm.id},on:{"setTab":_vm.setTab}})}
var staticRenderFns = []

export { render, staticRenderFns }